import { createContext, ReactNode, useContext, useState } from "react";
import { Toast, ToastMessageProps } from "~components";

export type ToastContextProps = {
  showToast: (toastMessage: ToastMessageProps) => void;
};
export const ToastContext = createContext<ToastContextProps | null>(null);

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toastMessage, setToastMessage] = useState<ToastMessageProps>(null);

  function showToast(toastMessage: ToastMessageProps) {
    setToastMessage(toastMessage);
  }

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <Toast message={toastMessage} onClose={() => setToastMessage(null)} />
    </ToastContext.Provider>
  );
}

export const noopToastContext: ToastContextProps = { showToast: () => {} };

export function useToastMessage() {
  const context = useContext(ToastContext);
  if (context === null) {
    // Every generated hook now calls useToastMessage via apolloHooks.tsx, so a missing
    // ToastProvider would silently swallow errors.
    console.warn("useToastMessage called without a ToastProvider — toasts will not be shown.");
    return noopToastContext;
  }
  return context;
}

export const STANDARD_TOAST_ERROR: ToastMessageProps = {
  title: "Something went wrong and we've been notified about the issue.",
  variant: "error",
};
